/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useCallback, useState, useEffect } from 'react';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalGroupBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalGroupBtn';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Radio from '@wconcept/wconcept-ui-renewal/components/atoms/Radio';
import { IconCheck01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  onSubmit?: (data: any) => void;
  onClose?: () => void;
  value: {
    options: {
      title?: string;
      text?: string;
      tooltip?: React.JSX.Element;
      value: string;
      checked: boolean;
      options?: {
        text: string;
        value: string;
        checked: boolean;
      }[];
    }[];
  };
}

const SortingModal = ({ onSubmit, onClose, value }: IProps) => {
  const { options } = value || {};
  const [$options, setOptions] = useState(options || []);

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  const handleSubmit = useCallback(
    (updatedOptions: any) => {
      if (typeof onSubmit === 'function') {
        onSubmit(updatedOptions || $options);
      }
    },
    [$options, onSubmit]
  );

  const handleSubmitGroup = useCallback(() => {
    handleSubmit($options);
  }, [$options, handleSubmit]);

  const onChangeRadio = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const updatedOptions = $options.map((v: { value: string }) =>
        v.value === e.target.value
          ? { ...v, checked: e.target.checked }
          : { ...v, checked: false }
      );

      setOptions(updatedOptions);
      handleSubmit(updatedOptions);
    },
    [$options, handleSubmit]
  );

  const onChangeRadioGroup = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, groupIndex: number) => {
      setOptions((prev: any) =>
        prev.map((group: any, index: number) =>
          index === groupIndex
            ? {
                ...group,
                options: group.options.map((option: any) =>
                  option.value === e.target.value
                    ? { ...option, checked: e.target.checked }
                    : { ...option, checked: false }
                ),
              }
            : group
        )
      );
    },
    []
  );

  return (
    <S.SortingModal>
      <ModalEdgeCloseBtn onClick={handleClose} />
      <div className="content">
        {$options?.[0]?.options ? (
          <ul className="opt-group">
            {$options &&
              $options?.map((v: any, groupIndex: number) => (
                <li key={v.title}>
                  <Text className="title">{v.title}</Text>
                  {v.options.length > 0 && (
                    <ul className="og-list">
                      {v.options.map((v2: any) => (
                        <li
                          key={`${v.title}-${v2.value}`}
                          className={v2.checked ? 'active' : ''}
                        >
                          <Radio
                            name={`${v.title}-${v2.value}`}
                            checked={v2.checked}
                            label={v2.text}
                            value={v2.value}
                            onChange={e => onChangeRadioGroup(e, groupIndex)}
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
        ) : (
          <ul className="opt-single">
            {$options &&
              $options?.map((v: any) => (
                <li key={v.value} className={v.checked ? 'active' : ''}>
                  <Radio
                    name="opt-single"
                    checked={v.checked}
                    label={v.text}
                    value={v.value}
                    tooltip={v.tooltip}
                    onChange={onChangeRadio}
                  />
                  {v.checked && <IconCheck01 />}
                </li>
              ))}
          </ul>
        )}
      </div>
      {$options?.[0]?.options && (
        <ModalGroupBtn
          secondaryBtn={{ text: '취소', onClick: handleClose }}
          primaryBtn={{ text: '적용', onClick: handleSubmitGroup }}
        />
      )}
    </S.SortingModal>
  );
};

export default SortingModal;
